import { Route, RouteGroup } from '@billow/easy-route'
import { view } from '@/utilities/view'

export default RouteGroup({
  // middleware: ['guest'],

  routes: [
    Route('/login', 'login', view('auth/Login'))
  ]
})